import { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, Play } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { loadFreeVideosPage } from '../lib/library';
import type { FreeVideo } from '../lib/library';
import { Button, CourseArtwork, EmptyState, LoadingState, SectionHeading } from '../components/ui';

const PAGE_SIZE = 15;

export function StudentFreeVideos() {
  const navigate = useNavigate();
  const [state, setState] = useState<{ page: number; items: FreeVideo[]; total: number; failed: boolean }>({ page: -1, items: [], total: 0, failed: false });
  const [page, setPage] = useState(0);

  useEffect(() => {
    let active = true;
    void loadFreeVideosPage(page, PAGE_SIZE)
      .then(({ items, total }) => { if (active) setState({ page, items, total, failed: false }); })
      .catch(() => { if (active) setState((prev) => ({ ...prev, page, items: [], total: prev.total, failed: true })); });
    return () => { active = false; };
  }, [page]);

  const loading = state.page !== page;
  const videos = state.failed ? [] : state.items;
  const total = state.failed ? 0 : state.total;
  const pageCount = Math.max(1, Math.ceil(total / PAGE_SIZE));
  return <div className="tests-page">
    <section className="page-title-row"><div><h1>Free videos</h1><p>Demo lectures open to every learner — no subscription needed</p></div></section>
    <section className="test-list-section">
      <SectionHeading title={total ? `Available lectures · ${total}` : 'Available lectures'} />
      {loading ? <LoadingState /> : videos.length
        ? <div className="subject-list">{videos.map((video) => (
          <button className="subject-row video-row" key={video.objectId} onClick={() => navigate(`/video/${video.objectId}`)}>
            <CourseArtwork index={0} icon="play" image={video.VideoLogo} />
            <div><strong>{video.VideoName}</strong><small>{video.VideoDuration ? `${Math.round(video.VideoDuration / 60)} min` : 'Lecture'} · Free demo lecture</small></div>
            <Play size={15} />
          </button>
        ))}</div>
        : <EmptyState title="No free videos yet" description="Demo lectures appear here as soon as faculty publishes them." action={<Button variant="soft" onClick={() => navigate('/courses')}>Browse courses</Button>} />}
      {total > PAGE_SIZE && <div className="pagination-row">
        <Button variant="ghost" icon={ChevronLeft} disabled={page === 0 || loading} onClick={() => setPage((value) => Math.max(0, value - 1))}>Previous</Button>
        <span className="pagination-label">Page {page + 1} of {pageCount}</span>
        <Button variant="ghost" disabled={page + 1 >= pageCount || loading} onClick={() => setPage((value) => value + 1)}>Next <ChevronRight size={16} /></Button>
      </div>}
    </section>
  </div>;
}
